/**
 * Created by root on 9/11/16.
 */
define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var BaseApiService = require('web-agent-utils/BaseApiService');

    var lpBaseService = function (options) {
        this.logger = WebAgentLogger.getLogger(this.applicationType);
        this.serviceName = options && options.serviceName;

        if (this.serviceName) {
            this.logger.debug('creating service end point configuration.');
            this.apiResourceService = agentLEManager.getLEUrlResolverApiResourcesService(this.serviceName);
        } else {
            this.logger.error('no service name supplied, cannot setup service.');
        }
    };

    lpBaseService.prototype.applicationType = 'lpBaseService';

    lpBaseService.prototype.createAPIEndPointService = function (apiEndPointName) {

        if (!this.apiResourceService) {
            return;
        }

        if (this.apiResourceService[apiEndPointName] && this.apiResourceService[apiEndPointName].url) {
            var apiEndPointURL = this.apiResourceService[apiEndPointName].url;
            var fullResourceUrl = agentLEManager.getLEUrlResolverGetUrl(apiEndPointURL);
            var resourceDomainUrl = lpUtils.getSubDomain(fullResourceUrl);

            var apiResource = BaseApiService.createInstance({
                domainUrl: lpUtils.getSubDomain(resourceDomainUrl),
                postmessagePath: "/postmessage",
                serviceName: this.serviceName
            });

            apiResource.additionalUrl = fullResourceUrl.substring(resourceDomainUrl.length);
            return apiResource;
        } else {
            this.logger.error("the service: " + this.serviceName + " dose not contains definition for " + apiEndPointName + " endPoint. see apiResources.json file.");
        }
    };


    return lpBaseService;

});
